/* Gemians Bundle Box
 *
 * The visible box, amounts included, is server-rendered Liquid. This file
 * switches the tabs, keeps the block's own quantity field on the bottles of
 * the chosen card, and keeps the Kaching Subscriptions widget on the matching
 * purchase option: its one time card for the one time tab, its subscription
 * card plus the card's plan for the subscription tab. The widget stays in the
 * DOM as the engine that owns the selling_plan input inside the theme's form.
 * It is only ever clicked, and only while it disagrees with the box
 * (exception N1 in CLAUDE.md). The file also moves the theme's buy button
 * block into the box footer, and a Kaching app block of the same section
 * with it.
 */
(function () {
  'use strict';

  var ROOT = '[data-gem-bundlebox]';
  var WIDGET = 'kaching-subscriptions-block-v2';
  var SUB_CARD = '.kaching-subscriptions__card-wrapper:not(.one-time-purchase)';
  var ONETIME_CARD = '.kaching-subscriptions__card-wrapper.one-time-purchase';
  var TRIGGER = '.kaching-subscriptions__dropdown-trigger-wrapper';
  var ITEM = '.kaching-subscriptions__dropdown-item';
  var RADIO = '.gemians-bundlebox__radio';

  /* Looks allowed to bring the widget to one choice. Reaching a plan takes
   * three clicks at most (subscription card, dropdown, plan), so running out
   * means the widget cannot show that choice and going on would only loop. */
  var MAX_STEPS = 12;
  /* After a click the widget re-renders on its own schedule; the next click
   * waits this long so it never lands on a half drawn widget. */
  var SETTLE = 250;
  /* How long an add to cart waits for the widget to catch up with a choice
   * made a moment earlier, before it goes ahead anyway. */
  var SUBMIT_WAIT = 1500;

  var instances = new WeakMap();

  /* The widget lists its plans in the order of its own config, read here and
   * never written. Plan names can repeat when a product keeps an older plan,
   * so the position is what tells two plans apart. */
  function planOrder(widget) {
    try {
      var cfg = JSON.parse(widget.getAttribute('config') || '{}');
      var variants = (cfg.product && cfg.product.variants) || [];
      var current = String(cfg.currentVariantId || '');
      var variant = variants[0];
      for (var i = 0; i < variants.length; i++) {
        if (String(variants[i].id) === current) variant = variants[i];
      }
      return ((variant && variant.sellingPlans) || []).map(function (plan) {
        return String(plan.id);
      });
    } catch (e) {
      return [];
    }
  }

  function itemFor(widget, items, planId) {
    var order = planOrder(widget);
    var index = order.indexOf(String(planId));
    if (index < 0 || items.length !== order.length) return null;
    return items[index];
  }

  function Instance(root) {
    this.root = root;
    this.kind = root.getAttribute('data-gem-default') === 'onetime' ? 'onetime' : 'subscription';
    /* data-gem-qty-field, not data-gem-qty: every card radio carries
     * data-gem-qty with its bottles, and the first of them would match. */
    this.qty = root.querySelector('[data-gem-qty-field]');
    this.form = null;
    this.observer = null;
    this.timer = null;
    this.steps = 0;
    this.busyUntil = 0;
    this.passNext = false;
    this.sync = this.sync.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  Instance.prototype.paint = function () {
    var root = this.root;
    var kind = this.kind;
    var tabs = root.querySelectorAll('[data-gem-tab]');
    var i;
    for (i = 0; i < tabs.length; i++) {
      var on = tabs[i].getAttribute('data-gem-tab') === kind;
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      tabs[i].tabIndex = on ? 0 : -1;
    }
    var panels = root.querySelectorAll('[data-gem-panel]');
    for (i = 0; i < panels.length; i++) {
      panels[i].hidden = panels[i].getAttribute('data-gem-panel') !== kind;
    }
    root.setAttribute('data-gem-kind', kind);
  };

  /* What the open tab asks for: bottles, and the plan on the subscription
   * tab. A tab whose chosen card is missing falls back to its first card. */
  Instance.prototype.choice = function () {
    var panel = this.root.querySelector('[data-gem-panel="' + this.kind + '"]');
    if (!panel) return null;
    var radio = panel.querySelector(RADIO + ':checked') || panel.querySelector(RADIO);
    if (!radio) return null;
    if (!radio.checked) radio.checked = true;
    return {
      kind: this.kind,
      qty: Math.max(1, parseInt(radio.getAttribute('data-gem-qty'), 10) || 1),
      plan: this.kind === 'subscription' ? radio.getAttribute('data-gem-plan') || '' : ''
    };
  };

  Instance.prototype.applyQty = function () {
    var choice = this.choice();
    if (choice && this.qty) this.qty.value = String(choice.qty);
  };

  /* The quantity field names the theme's form in its form attribute. If the
   * theme ever renames the form, find it in the section and point the field
   * at it instead. getAttribute, because form.id returns the input named id. */
  Instance.prototype.findForm = function () {
    var qty = this.qty;
    if (qty && qty.form) return qty.form;
    var section = this.root.closest('.shopify-section') || document;
    var form = section.querySelector('product-form form[action*="/cart/add"]');
    if (form && qty && form.getAttribute('id')) qty.setAttribute('form', form.getAttribute('id'));
    return form || null;
  };

  Instance.prototype.widget = function () {
    var section = this.root.closest('.shopify-section') || document;
    return this.root.querySelector(WIDGET) || section.querySelector(WIDGET);
  };

  Instance.prototype.planValue = function () {
    var input = this.form ? this.form.querySelector('input[name="selling_plan"]') : null;
    return input && !input.disabled ? input.value : '';
  };

  /* No widget means there is nothing to keep in step with, so the box never
   * holds the add to cart back waiting for one. */
  Instance.prototype.agrees = function (choice) {
    var widget = this.widget();
    if (!widget || !choice) return true;
    if (choice.kind === 'onetime') {
      var one = widget.querySelector(ONETIME_CARD);
      return !!one && one.classList.contains('selected') && this.planValue() === '';
    }
    var sub = widget.querySelector(SUB_CARD);
    return !!sub && sub.classList.contains('selected') && this.planValue() === String(choice.plan);
  };

  /* At most one click toward the choice; true when it clicked. A dropdown
   * that is open but not drawn yet is left alone for the next round. */
  Instance.prototype.step = function (choice) {
    var widget = this.widget();
    if (!widget) return false;
    if (choice.kind === 'onetime') {
      var one = widget.querySelector(ONETIME_CARD);
      if (!one || one.classList.contains('selected')) return false;
      one.click();
      return true;
    }
    var sub = widget.querySelector(SUB_CARD);
    if (!sub) return false;
    if (!sub.classList.contains('selected')) {
      sub.click();
      return true;
    }
    var items = widget.querySelectorAll(ITEM);
    if (items.length) {
      var item = itemFor(widget, items, choice.plan);
      if (!item) return false;
      item.click();
      return true;
    }
    var trigger = widget.querySelector(TRIGGER);
    if (!trigger || trigger.getAttribute('aria-expanded') === 'true') return false;
    trigger.click();
    return true;
  };

  Instance.prototype.sync = function () {
    this.timer = null;
    var choice = this.choice();
    if (this.agrees(choice)) {
      this.steps = 0;
      this.busyUntil = 0;
      return;
    }
    if (Date.now() < this.busyUntil) {
      this.later();
      return;
    }
    if (this.steps >= MAX_STEPS) return;
    this.steps++;
    if (this.step(choice)) this.busyUntil = Date.now() + SETTLE;
    this.later();
  };

  Instance.prototype.later = function () {
    if (this.timer) return;
    this.timer = setTimeout(this.sync, 120);
  };

  /* A new choice: bottles first, then the widget. */
  Instance.prototype.retarget = function () {
    this.steps = 0;
    this.busyUntil = 0;
    this.applyQty();
    this.sync();
  };

  Instance.prototype.select = function (kind) {
    if (kind !== 'subscription' && kind !== 'onetime') return;
    if (kind !== this.kind) this.carryChoice(this.kind, kind);
    this.kind = kind;
    this.paint();
    this.retarget();
  };

  /* The pick follows the customer across tabs: card 2 on one tab opens card 2
   * on the other. Each card brings its own bottles, plan and amounts, so the
   * usual retarget does the rest, exactly as if the card had been clicked. */
  Instance.prototype.carryChoice = function (from, to) {
    var fromPanel = this.root.querySelector('[data-gem-panel="' + from + '"]');
    var toPanel = this.root.querySelector('[data-gem-panel="' + to + '"]');
    if (!fromPanel || !toPanel) return;
    var picked = fromPanel.querySelector(RADIO + ':checked');
    if (!picked) return;
    var match = toPanel.querySelector(RADIO + '[value="' + picked.value + '"]');
    if (match) match.checked = true;
  };

  /* Moves a block of the section into the footer, unless it is the box itself
   * or already inside it. */
  Instance.prototype.adopt = function (el) {
    var root = this.root;
    var footer = root.querySelector('[data-gem-footer]');
    if (!footer || !el) return;
    var blockEl = el.closest('.shopify-block') || el;
    if (blockEl === root || root.contains(blockEl) || blockEl.contains(root)) return;
    footer.appendChild(blockEl);
  };

  /* On a product page the Kaching widget comes from the app embed, inside the
   * buy button block, so it travels with it. A section with its own Kaching
   * app block, such as the featured product on the home page, keeps the
   * widget outside: that block is moved whole, its wrapper only, so the same
   * footer rule hides it. */
  Instance.prototype.adoptBuyButton = function () {
    var section = this.root.closest('.shopify-section') || document;
    this.adopt(section.querySelector('product-form'));
    this.adopt(section.querySelector('kaching-subscriptions'));
  };

  Instance.prototype.onClick = function (e) {
    var tab = e.target.closest ? e.target.closest('[data-gem-tab]') : null;
    if (!tab || !this.root.contains(tab)) return;
    var kind = tab.getAttribute('data-gem-tab');
    if (kind === this.kind) return;
    this.select(kind);
  };

  Instance.prototype.onKeydown = function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var tab = e.target.closest ? e.target.closest('[data-gem-tab]') : null;
    if (!tab || !this.root.contains(tab)) return;
    var tabs = Array.prototype.slice.call(this.root.querySelectorAll('[data-gem-tab]'));
    var next = tabs[(tabs.indexOf(tab) + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
    if (!next) return;
    e.preventDefault();
    next.focus();
    this.select(next.getAttribute('data-gem-tab'));
  };

  Instance.prototype.onChange = function (e) {
    var target = e.target;
    if (!target || !target.matches || !target.matches(RADIO)) return;
    this.retarget();
  };

  /* Runs before the theme's own submit handler. The bottles are set again
   * here, and if the widget is still on another option, the add to cart waits
   * for it before going ahead, so the cart never mixes one card's bottles with
   * another card's plan. */
  Instance.prototype.onSubmit = function (e) {
    if (!this.form || e.target !== this.form) return;
    this.applyQty();
    var choice = this.choice();
    if (this.passNext || this.agrees(choice)) {
      this.passNext = false;
      return;
    }
    e.preventDefault();
    e.stopImmediatePropagation();
    var self = this;
    var form = this.form;
    var submitter = e.submitter && e.submitter.form === form ? e.submitter : null;
    var started = Date.now();
    this.steps = 0;
    this.sync();
    (function wait() {
      if (!self.agrees(choice) && Date.now() - started < SUBMIT_WAIT) {
        setTimeout(wait, 100);
        return;
      }
      self.passNext = true;
      if (form.requestSubmit) {
        if (submitter) form.requestSubmit(submitter);
        else form.requestSubmit();
      } else if (submitter) {
        submitter.click();
      } else {
        self.passNext = false;
      }
    })();
  };

  /* The app mounts and re-renders on its own schedule. Any change inside the
   * footer, where the widget lives, triggers one more look. */
  Instance.prototype.watch = function () {
    var self = this;
    var target = this.root.querySelector('[data-gem-footer]') || this.root;
    this.observer = new MutationObserver(function () {
      self.later();
    });
    this.observer.observe(target, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  };

  Instance.prototype.start = function () {
    this.adoptBuyButton();
    this.form = this.findForm();
    this.paint();
    this.applyQty();
    this.root.addEventListener('click', this.onClick);
    this.root.addEventListener('keydown', this.onKeydown);
    this.root.addEventListener('change', this.onChange);
    document.addEventListener('submit', this.onSubmit, true);
    this.watch();
    this.sync();
  };

  Instance.prototype.stop = function () {
    this.root.removeEventListener('click', this.onClick);
    this.root.removeEventListener('keydown', this.onKeydown);
    this.root.removeEventListener('change', this.onChange);
    document.removeEventListener('submit', this.onSubmit, true);
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      if (instances.has(roots[i])) continue;
      var inst = new Instance(roots[i]);
      instances.set(roots[i], inst);
      inst.start();
    }
  }

  function teardown(scope) {
    var roots = (scope || document).querySelectorAll(ROOT);
    for (var i = 0; i < roots.length; i++) {
      var inst = instances.get(roots[i]);
      if (!inst) continue;
      inst.stop();
      instances.delete(roots[i]);
    }
  }

  function boxFor(target) {
    return target && target.closest ? target.closest(ROOT) : null;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { teardown(e.target); });

  /* In the theme editor, selecting the block re-runs init for a box the
   * editor just re-rendered; deselecting puts the box back on its default
   * tab, so what the merchant sees matches what a customer gets on load. */
  document.addEventListener('shopify:block:select', function (e) {
    init(e.target.closest('.shopify-section') || document);
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var root = boxFor(e.target);
    var inst = root ? instances.get(root) : null;
    if (inst) inst.select(root.getAttribute('data-gem-default'));
  });
})();
